import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./DresserList.module.css";
import { ReactComponent as ArrowLeftIcon } from "../assets/icons/arrowLeft.svg";
import PersianDateDisplay from "../components/TopSection/PersianDateDisplay";
import { DateTime } from "ts-luxon";
import { useTheme } from "../ThemeContext";

import { useDispatch } from "react-redux"; 
import { setActiveTab } from "../store/tabSlice"; 

interface Dresser {
  id: number;
  name: string;
  service: string;
  date: string; // ISO format or "نامشخص"
  avatar: string;
  categories: number[];
  icon?: string;
}

interface DresserCardProps {
  dresser: Dresser;
  categories: any[];
}

const DresserCard: React.FC<DresserCardProps> = ({ dresser, categories }) => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const dispatch = useDispatch(); 
  const handleReserveClick = () => {
    dispatch(setActiveTab("appointments")); 
    navigate(
      `/times?partnerId=${dresser.id}&stylist=${encodeURIComponent(dresser.name)}&date=${dresser.date}`
    );
  };
  

  const getServiceIcons = (categoryIds: number[]) => {
    return categoryIds.map((id) => {
      const category = categories.find((cat) => cat.id === id);
      return category ? category.logo : null;
    });
  };

  const serviceIcons = getServiceIcons(dresser.categories);

  const formattedDate = dresser.date && dresser.date !== "نامشخص"
    ? DateTime.fromISO(dresser.date)
    : null;

  return (
    <div className={styles.dresserCard}>
      <div className={styles.cardContent}>
        <div className={styles.serviceIcons}>
          {serviceIcons.map((icon, index) =>
            icon ? (
              <img
                key={index}
                src={`/assets/icons/categories/${
                  isDarkMode ? icon.replace(".", "-dark.") : icon
                }`}
                alt="Service Icon"
                className={styles.icon}
              />
            ) : null
          )}
        </div>

        <div className={styles.info}>
          <h6 className={styles.name}>{dresser.name || "نامشخص"}</h6>
          <p className={styles.service}>{dresser.service || "بدون سرویس"}</p>
        </div>

        <div className={styles.avatarContainer}>
          <img
            src={dresser.avatar || ""}
            alt="Avatar"
            className={styles.avatar}
          />
        </div>
      </div>

      <div className={styles.footerBar}>
        <span className={styles.date}>
          اولین وقت خالی:{" "}
          {formattedDate ? (
            <PersianDateDisplay
              date={formattedDate}
              showDay={true}
              showMonthAsNumber={false}
            />
          ) : (
            "نامشخص"
          )}
        </span>
        <div className={styles.reserveContainer} onClick={handleReserveClick}>
          <ArrowLeftIcon className={styles.arrowIcon} />
          <span className={styles.reserveText}>رزرو نوبت</span>
        </div>
      </div>
    </div>
  );
};

export default DresserCard;
